import { IStore } from 'store/configureStore';
import { selectSubmittingOrgState } from 'modules/settings/submodules/clients/submittingOrg/store/selectors';

export const selectIsSubmittingOrgStatusUpdating = (state: IStore) => {
    const submittingOrgState = selectSubmittingOrgState(state);
    return submittingOrgState.isSubmittingOrgStatusUpdating;
};
